module.exports = __webpack_public_path__ + "static/media/Agri-producer Infographic GBR network Mobile 22-02-2024 C.e00c1f0f.gif";